<template>
    <LayoutDefault>
        <div class="container-fluid banner-plb pb-5 cloud-page"
            :style="{ backgroundImage: banner && banner.path
      ? `url(${images_fpt(banner.path, banner.mob)})`
      : 'none'
  }">
            <div class="backdrop-image"></div>
            <section-banner :title="landingInfo.pageTitle" :description="landingInfo.pageDescription"></section-banner>
            <SectionTypeSekeleton v-if="isFirstLoaded">
                <template #body>
                    <div class="d-flex box flex-column flex-md-row">
                        <!-- info image -->
                        <b-skeleton-img card-img="left" width="400px" height="300px"></b-skeleton-img>
                        <!-- info detail -->
                        <div class="flex-fill">
                            <b-skeleton-table :rows="5" :columns="2"></b-skeleton-table>
                        </div>
                    </div>
                </template>
            </SectionTypeSekeleton>
            <div v-else>
                <section-type idSection="fpt-cloud" :title="landingInfo.pageTitle" :tabs="sectionTabsData"
                    :loading="loading" :optionQuantity="optionQuantity" :label="landingInfo" module="cloud"
                    v-model="selectedTab" @onProgress="onProgress" v-if="sectionTabsData && sectionTabsData.length > 0">
                    <div v-for="(tab, tabIndex) in sectionTabsData" :slot="tab.CmsContent.service_code" class="row gutter-24 pb-1"
                        :key="`section-choose-package-cloud-${tabIndex}-${tab.CmsContent.service_code}`">
                        <!-- info image -->
                        <div class="col-lg-6">
                            <div class="image-box mobile-image m-0">
                                <img v-bind:src="images_fpt(tab.CmsContent.content.cloud_content_image_path, tab.CmsContent.content.cloud_content_image_mobile_path)"
                                    :alt="images_fpt(tab.CmsContent.content.cloud_content_image_alt, tab.CmsContent.content.cloud_content_image_mobile_alt)" />
                            </div>
                        </div>

                        <!-- info detail -->
                        <div class="col-lg-6">
                            <div class="info">
                                <div class="row" id="cloud-detail"
                                    v-for="(feature, featureIndex) in tab.CmsContent.content.features"
                                    :key="`tab-${tabIndex}-detail-${featureIndex}`">
                                    <div class="content-icon">
                                        <i class="ico ico-tick mr-3"></i>
                                    </div>
                                    <div class="detail-info">
                                        <p class="text-med detail-text" v-text="feature.cloud_feature_description"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section-type>
            </div>
            <section-function :functions="sectionFunctionsData"></section-function>
            <section-news :serviceCode="serviceCode"></section-news>
        </div>
        <b-modal ref="note-modal" hide-footer :title="landingInfo.note" v-model="toggleNote">
            <p v-html="landingInfo.noteDescription"></p>
        </b-modal>
        <!-- <section-footer></section-footer> -->
    </LayoutDefault>
</template>

<style scoped>
#cloud-detail {
    flex-wrap: unset !important;
}

.cloud-page .ico.ico-tick {
    background-image: url('/shop/images/icon-tick-orange.svg') !important;
    background-repeat: no-repeat;
    height: 16px;
    width: 16px;
}

.mobile-image {
    display: block;
}

@media all and (max-width: 768px) {
    .mobile-image {
        display: none;
    }
}
</style>

<script>
import {
    MAX_QUANTITY,
    MIN_QUANTITY,
    SERVICE_CODE,
    PAYMENT_FLOW,
} from '../../../configs/constants';
import * as api from '../module/api';
import * as cms from '../module/cms';
import { mixins } from '../../mixin';
import isMobile from '@/mycore/utils/mobile-detect';
import SectionTypeSekeleton from '@/mycore/components/SectionTypeSekeleton.vue';
const PAGE_SERVICE_CODE = 'cloud'
export default {
    mixins: [mixins],
    components: { SectionTypeSekeleton },
    data() {
        return {
            banner: {
                path: 'https://hi-static.fpt.vn/sys/shop/prod/2022-06-01/6296defa5a811_424f1c09-cc93-4162-a982-5f16dd16accb.jpg',
                mob: 'https://hi-static.fpt.vn/sys/shop/prod/2022-06-01/6296defa5a811_424f1c09-cc93-4162-a982-5f16dd16accb.jpg',
                alt: '',
            },
            imageList: [],
            urlPaymentFlow: PAYMENT_FLOW.CLOUD,
            loading: true,
            image: null,
            toggleNote: false,
            landingInfo: {
                pageTitle: 'FPT Cloud',
                pageDescription: 'Dịch vụ lưu trữ dữ liệu đám mây tại Việt Nam <br> Ổn định - An toàn - Bảo mật cao',
                note: 'Chú thích',
                noteTitle: '',
                noteDescription:
                    'Miễn phí lắp đặt lần đầu cho khách hàng đang sử dụng Internet FPT.<br />Quý khách vui lòng điền số CMND dùng cho hợp đồng internet hiện tại và chọn đúng vị trí muốn lắp đặt cloud để nhận ưu đãi',
                buyNow: 'Mua ngay',
                comingSoon: 'Chưa mở bán',
                infoCustomer: 'Dành cho khách hàng đã có hợp đồng FPT Cloud',
            },
            optionQuantity: {
                maxValue: MAX_QUANTITY,
                minValue: MIN_QUANTITY,
            },
            listMeta: {},
            sectionTabsData: [],
            sectionFunctionsData: [
                {
                    backgroundClass: 'func-setting',
                    isNonSVG: true,
                    icon: '/assets/images/cloud1.png',
                    label: 'Lưu trữ đám mây không cần ổ cứng',
                },
                {
                    backgroundClass: 'func-connect',
                    isNonSVG: true,
                    icon: '/assets/images/cloud2.png',
                    label: 'Chia sẻ với nhiều ứng dụng',
                },
                {
                    backgroundClass: 'func-voice',
                    isNonSVG: true,
                    icon: '/assets/images/cloud3.png',
                    label: 'Bảo mật an toàn',
                },
                {
                    backgroundClass: 'func-content',
                    isNonSVG: true,
                    icon: '/assets/images/cloud4.png',
                    label: 'Cài đặt dễ dàng',
                },

            ],
            sectionTermData: [
                {
                    icon: '/term-bh',
                    label: 'Bảo hành 1 đổi 1 trong 24 tháng',
                },
                {
                    icon: '/term-check',
                    label: 'Kiểm tra trước khi nhận hàng',
                },
                {
                    icon: '/term-support',
                    label: 'Hỗ trợ khách hàng 24/7',
                },
            ],
            serviceCode: SERVICE_CODE.CLOUD,
            urlPaymentFlow: PAYMENT_FLOW.CLOUD,
            selectedTab: {},
            cloudData: [],
            isFirstLoaded: true,
        };
    },
    created() {
        // xu ly khi du lieu parse khong dung
        try {
            this.listMeta = JSON.parse(localStorage.getItem('meta_seo'));
        } catch (e) {};
        this.loadCachedData();
    },
    mounted() {
        this.load();
        this.getUTM();
    },
    watch: {
        selectedTab(value) {
            if (value) {
                this.imageList = [
                    {
                        src: isMobile() && value.cloud_image_mobile_path ? value.cloud_image_mobile_path : value.cloud_image_path,
                        alt: value.cloud_image_alt,
                        position: value.position,
                    }
                ]
                this.getMetaSeo();

            }
        },
    },

    methods: {
        clearSession() {
            this.$store.dispatch('ultraFast/clearSession');
            this.$store.dispatch('fptplay/clearSession');
            this.$store.dispatch('fptplaybox/clearSession');
            this.$store.dispatch('camera/clearSession');
            this.$store.dispatch('cloud/clearSession');
            this.$store.dispatch('fsafe_go_extend/clearSession');
            this.$store.dispatch('internet/clearSession');
        },
        handleCommingSoon(e) {
            this.commingSoon = e;
        },
        loadCachedData() {
            const cloudLocalData = this.$store.getters['cloud/cloudLocalData'];
            if (cloudLocalData) {
                const { Tabs, Label, Banner } = cloudLocalData;
                this.sectionTabsData = Tabs || [];
                this.label = Label;
                this.banner = Banner;
                if (this.sectionTabsData.length > 0) {
                    this.getCurrentTab();
                }
                this.isFirstLoaded = false;
            }
        },
        getUTM() {
            if (this.$route.query.utm_source) {
                sessionStorage.utm_source = this.$route.query.utm_source || '';
                sessionStorage.utm_medium = this.$route.query.utm_medium || '';
                sessionStorage.utm_campaign = this.$route.query.utm_campaign || '';
                sessionStorage.utm_term = this.$route.query.utm_term || '';
                sessionStorage.utm_content = this.$route.query.utm_content || '';
            }

            if (this.$route.query.aff_sid) {
                sessionStorage._aff_sid = this.$route.query.aff_sid || '';

                const d = new Date();
                d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
                let expires = 'expires=' + d.toUTCString();

            }
        },
        getCurrentTab() {
            const routeName = this.$route.params['servicecode'];
            this.selectedTab = routeName ? this.sectionTabsData.find((tab) => tab.CmsContent.route_name === routeName) || this.sectionTabsData[0] : this.sectionTabsData[0];
            if (this.selectedTab.CmsContent.route_name !== routeName) {
                this.$router.replace({ path: `/${PAGE_SERVICE_CODE}/${this.selectedTab.CmsContent.route_name}` }).catch(() => { });
            }

            this.imageList = [
                {
                    src: isMobile() && this.selectedTab.cloud_image_mobile_path ? this.selectedTab.cloud_image_mobile_path : this.selectedTab.cloud_image_path || '',
                    alt: this.selectedTab.cloud_image_alt || '',
                    position: this.selectedTab.position || 0,
                }
            ]
            this.getMetaSeo();


        },
        load() {
            sessionStorage.isPage = 'Cloud';
            this.clearSession();
            cms.getLandingBanner(this.mappingBanner, PAGE_SERVICE_CODE);
            api.getCategories(this.getCategoriesCallback);
        },
        getCategoriesCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    const response = data.data;
                    const cachedTabsData = this.$store.getters['cloud/Tabs'];

                    this.sectionTabsData = response.map(item => {
                        const temp = cachedTabsData.find(tab => tab.CmsContent.service_code === item.service_code);
                        return {
                            ...item,
                            Qty: temp ? temp?.Qty : 1,
                        }

                    });
                    if (this.sectionTabsData.length > 0) {
                        this.getCurrentTab();
                    }
                    this.loading = false;
                    this.$store.dispatch('cloud/updateTabs', this.sectionTabsData);

                }
                else {
                    if (this.sectionTabsData.length > 0) {
                        this.sectionTabsData.forEach(item => {
                            item.RealPromotionMonth = 0
                            item.RealMonth = 0
                        })
                        this.getCurrentTab();
                    }
                }


            } else {
                if (this.sectionTabsData.length > 0) {
                    this.sectionTabsData.forEach(item => {
                        item.RealPromotionMonth = 0
                        item.RealMonth = 0
                    })
                }
            }
            this.loading = false;
        },
        getMetaSeo() {
            if (Object.keys(this.listMeta).length > 0) {
                document.title = this.listMeta[this.selectedTab.CmsContent.service_code].title;
                document.getElementsByTagName('meta')['keywords'].content =
                    this.listMeta[this.selectedTab.CmsContent.service_code].keywords;
                document.getElementsByTagName('meta')['description'].content =
                    this.listMeta[this.selectedTab.CmsContent.service_code].description;
                //
                document
                    .querySelector('meta[property="og:url"]')
                    .setAttribute(
                        'content',
                        window.location.origin +
                        `/${this.serviceCode}/${this.selectedTab.CmsContent.service_code}`
                    );
                document.querySelector('meta[property="og:type"]').setAttribute('content', 'article');
                document
                    .querySelector('meta[property="og:title"]')
                    .setAttribute('content', this.listMeta[this.selectedTab.CmsContent.service_code].title);
                document
                    .querySelector('meta[property="og:description"]')
                    .setAttribute('content', this.listMeta[this.selectedTab.CmsContent.service_code].description);
                document
                    .querySelector('meta[property="og:image"]')
                    .setAttribute('content', this.listMeta[this.selectedTab.CmsContent.service_code].thumbnail);
            }

        },



        tabBinding($e) {
            this.selectedTab = $e;
        },
        mappingBanner: function (isSuccess, data, error) {
            if (isSuccess && data.error === 0) {
                const content = data.data;
                this.label = {
                    ...this.label,
                    pageTitle: content.landing_page_title,
                    pageDescription: content.landing_page_subtitle,
                };
                this.banner = {
                    ...this.banner,
                    path: content.landing_page_banner_path,
                    alt: content.landing_page_banner_alt,
                    mob: content.landing_page_banner_mobile_path,
                };
                this.$store.dispatch('cloud/updateBanner', this.banner);
                this.$store.dispatch('cloud/updateLabel', this.label);
            }
        },
        onProgress() {
            if (this.loading || this.commingSoon) return;
            this.$store.dispatch('cloud/updateSelectedPackage', this.selectedTab);
            window.scrollTo(0, 0);
            this.$router.push({ name: 'cloud.registerWithSCode', params: { servicecode: this.selectedTab.CmsContent.route_name } }).catch(() => { });
        },

    },
};
</script>
